exports = function(n, fn) {
    var memo;
    return function() {
        if (--n > 0) memo = fn.apply(this, arguments);
        if (n <= 1) fn = null;
        return memo;
    };
};

module.exports = exports;
